/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import apiNew from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import {
 getHistoryFailure,
 GetHistoryPayload,
 getHistoryStart,
 getHistorySuccess,
} from './historySlice';

function* getHistorySaga({ payload }: { payload: GetHistoryPayload }) {
 try {
  const response: AxiosResponse<any> = yield call(apiNew.post, '/History/v1', {
   filters: [
    {
     field: 'MainRecordId',
     operator: 'eq',
     value: payload.id,
     logic: 'And',
    },
    {
     field: 'Model',
     operator: 'eq',
     value: payload.model,
    },
   ],
  });

  yield put(
   getHistorySuccess({
    history: response.data,
   }),
  );
 } catch (error) {
  yield* errorHandling(error, getHistoryFailure);
 }
}

export function* watchHistorySaga() {
 yield takeLatest(getHistoryStart, getHistorySaga);
}
